
import http from 'common-module/src/util/http';

/**
 * 获取项目列表(有智能助理权限的项目)
 * @returns {AxiosPromise | Promise<any>}
 */
export const projectAssembleList = () => {
  return http.post('sys-automation/share/project/list', {}) as Promise<{
    id: number;
    pname: string;
  }[]>;
};


interface habitRecord {
  linkIdList?: string[]
  linkType: string
  projectId: number
  userId: number
}
export async function habitRecord(data: habitRecord) {
  return http.post('/account/habit-record', data);
}

export async function getHabitRecord(data: habitRecord) {
  return http.post('/account/habit-query', data);
}